/**
 * Shared scroll-in animation helper.
 *
 * Elements opt in via:
 *   data-scroll-animate="fade_in | fade_up | fade_down | fade_left | fade_right"
 *   data-scroll-delay="200"  (optional, ms)
 *
 * The matching CSS lives in base.css under "Scroll-in animations".
 */
function initScrollAnimations(root) {
  const scope = root || document;
  const elements = scope.querySelectorAll('[data-scroll-animate]:not([data-scroll-animate-init])');

  elements.forEach((el) => {
    el.setAttribute('data-scroll-animate-init', 'true');
    const delay = parseInt(el.getAttribute('data-scroll-delay') || '0', 10);

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.disconnect();
          setTimeout(() => el.classList.add('scroll-animate--visible'), delay);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initScrollAnimations());
} else {
  initScrollAnimations();
}

/* Re-run when sections are re-rendered in the theme editor */
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-scroll-animate]').forEach((el) => {
    el.removeAttribute('data-scroll-animate-init');
    el.classList.remove('scroll-animate--visible');
  });
  initScrollAnimations(event.target);
});

/* Initialize elements injected after page load (infinite scroll, filters,
   section re-renders) — otherwise they would stay at opacity 0 forever */
function observeDynamicContent() {
  if (!document.body) return;

  const observer = new MutationObserver((mutations) => {
    let needsInit = false;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('[data-scroll-animate]') || node.querySelector?.('[data-scroll-animate]')) {
          needsInit = true;
          break;
        }
      }
      if (needsInit) break;
    }

    if (needsInit) initScrollAnimations();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeDynamicContent);
} else {
  observeDynamicContent();
}
